import { useMantineColorScheme, ActionIcon } from "@mantine/core";
import { IconSun, IconMoon } from "@tabler/icons-react";
import classes from "./ThemeToggle.module.css";

export default function ThemeToggle({ status }) {
  const { colorScheme, setColorScheme } = useMantineColorScheme();

  return (
    <ActionIcon
      variant="outline"
      color={colorScheme === "dark" ? "yellow" : "blue"}
      onClick={() => setColorScheme(colorScheme === "dark" ? "light" : "dark")}
      title="Toggle color scheme"
      className={status === 'desktop' ? '' : classes.toggleMobile}
    >
      {colorScheme === "dark" ? <IconSun size={18} /> : <IconMoon size={18} />}
    </ActionIcon>
  );
}
